import { Component, computed, input } from '@angular/core';
import { TLingoSpotlightMood } from '../rid-lingo-spotlight/rid-lingo-spotlight';

// The glow hums slowly (with every letter a bit further along), or quickly while partying
const GLOW_MOODS: Record<TLingoSpotlightMood, string> = {
  IDLE: 'anim-glow [animation-delay:calc(var(--i)*-0.6s)]',
  FOCUS: 'anim-glow [animation-delay:calc(var(--i)*-0.6s)]',
  PARTY: 'anim-glow [animation-duration:0.4s]',
  // The sign is switched off: no glow, just the dull tubes
  DIM: 'brightness-55 saturate-70',
};

/**
 * The glowing neon title above the board. Follows the mood of the studio lights: it bounces along when the word was guessed and turns off when it wasn't.
 */
@Component({
  selector: 'rid-lingo-title',
  templateUrl: './rid-lingo-title.html',
  host: {
    // The spacing, glow and outline of the letters are in em, so they follow the font-size
    class: 'flex justify-center gap-[0.04em] font-heading text-[11rem] font-black leading-none select-none',
    '[attr.aria-label]': 'text()',
    role: 'heading',
  },
})
export class RidLingoTitle {
  text = input<string>('KLANKO');
  mood = input<TLingoSpotlightMood>('IDLE');

  letters = computed(() => [...this.text()]);
  isPartying = computed(() => this.mood() === 'PARTY');
  glowClass = computed(() => GLOW_MOODS[this.mood()]);
}
